import { render, staticRenderFns } from "./MCoupon.vue?vue&type=template&id=b678d508&"
import script from "./MCoupon.vue?vue&type=script&lang=ts&"
export * from "./MCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports